import React from "react";
import "./TopBalanceComponentTable.scss";
import { Button } from "..";
import {
  substring,
  fromNow,
  wei2Daon,
  wei2Gwei,
  toFixed,
} from "../../../helper";

function priceToString(price, type) {
  // return price.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  if (type == undefined || type == "balance") {
    price = parseFloat(price).toFixed(5);
  }
  const parts = price.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

const TopBalanceComponentTable = ({ props }) => {
  if (!props) return null;
  let accounts = props.accountList;
  let totalBalance = priceToString(wei2Daon(props.totalBalance));
  let totalAccounts = priceToString(props.totalAccounts, "account");
  let pageNum = props.pageNum <= 1 ? 1 : props.pageNum;
  let pageSize = props.pageSize;
  // let type = props.type;
  return (
    <div>
      {totalBalance === "1,000,000,000.00000" ? (
        <span
          style={{ fontSize: 15 }}
        >{`A total of ${totalAccounts} accounts found (${totalBalance} DEB)`}</span>
      ) : (
        <span
          style={{ fontSize: 15 }}
        >{`A total of ${totalAccounts} accounts found (${totalBalance} DEB.)`}</span>
      )}
      <div className="responsive_table">
        <table
          className={`table_type01 topBlance_Table ${
            props.type === "simple" && "simple"
          }`}
        >
          <thead>
            <tr>
              <th>RANK</th>
              <th>Address</th>
              <th>Balance</th>
              <th>Percentage</th>
              <th>Txn counts</th>
            </tr>
          </thead>
          <tbody>
            {accounts &&
              accounts.length > 0 &&
              accounts.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1 + (pageNum - 1) * pageSize}</td>
                  <td>
                    <Button
                      color="blue"
                      size="wide"
                      link={`/account/${item.Address}`}
                      tooltip={item.Address}
                    >
                      {props.type === "simple"
                        ? substring(item.Address)
                        : item.Address}
                    </Button>
                  </td>
                  <td>{priceToString(wei2Daon(toFixed(item.Balance)))} DEB</td>
                  <td>
                    {props.type === "simple"
                      ? item.Percentage.toFixed(3)
                      : parseFloat(toFixed(item.Percentage)).toFixed(8)}
                    %
                  </td>
                  <td>{item.TxnCount}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopBalanceComponentTable;
